<template>
  <div class="basic-info-box">
    <loading :isShow="$root.$children[0].isShowLoading" />

    <div class="action-box">
      <a><div class="cancel" @click="closePage">取消</div></a>
      <a><div class="save" @click="ok">保存</div></a>
    </div>

    <div class="user-info-box">
      <div class="img-type">
        <img class="head-portrait" v-if="basiInfo.icon" :src="basiInfo.icon">
        <img class="head-portrait" v-if="!basiInfo.icon&&userSex!=1&&userSex!=2" src="@/assets/images/icon/org/head.png">
        <img class="head-portrait" v-if="!basiInfo.icon&&userSex==1" src="@/assets/images/icon/org/sex-1.png">
        <img class="head-portrait" v-if="!basiInfo.icon&&userSex==2" src="@/assets/images/icon/org/sex-2.png">
        <span class="tag">{{ basiInfo.type=='2'?'自有':'预约' }}</span>
      </div>
      
      <div class="birthday-box">
        <div class="appointment-birthday">
          <div class="appointment" v-if="basiInfo.nextChatDate">
            <img src="@/assets/images/icon/org/calendar-icon.png">
            <div class="text">
              <span>已预约{{ handleAccessTime(basiInfo.nextChatDate) }}联系 / 拜访客户</span>
            </div>
          </div>
        </div>
        <a v-if="this.$config.env=='0'||this.$config.env=='2'" target="_blank" :href='`https://h5-test.lazhuyun.cn/policydeposit/policySteward?source=MGA&code=${userId}`'>保单托管 ></a>
        <a v-if="this.$config.env=='1'" target="_blank" :href='`https://h5.lazhuyun.cn/policydeposit/policySteward?source=MGA&code=${userId}`'>保单托管 ></a>
      </div>
    </div>

    <Form ref="form" :model="basiInfo" class="page-form">
      <div class="info-line">
        <div class="basic-item">
          <span class="label">姓名</span>
          <div class="value is-form">
            <FormItem prop="name" :rules="$units.formRule.required('请输入')">
              <Input v-model="basiInfo.name" placeholder="请输入" clearable />
            </FormItem>            
          </div>
        </div>

        <div class="basic-item">
          <span class="label">手机号</span>
          <span class="value" v-if="eyeShow">{{ basiInfo.mobile1 }}</span>
          <span class="value" v-else>{{ basiInfo.mobile }}</span>
          <a class="action-icon">
            <i class="iconfont iconxianshi eye-icon eye" v-if="eyeShow" @click="openEye"></i>
            <i class="iconfont iconyincang eye-icon eye" v-else @click="openEye"></i>
          </a>
        </div>

        <div class="basic-item">
          <span class="label">性别</span>
          <div class="value is-form">
            <Select clearable v-model="basiInfo.sex">
              <Option value="1">男</Option>
              <Option value="2">女</Option>
            </Select>            
          </div>
        </div>

        <div class="basic-item">
          <span class="label">生日</span>
          <div class="value is-form">
            <DatePicker
              type="date"
              format="yyyy-MM-dd"
              split-panels
              v-model="basiInfo.birthDate"
              placeholder="请选择"
              style="width:100%;"
            ></DatePicker>            
          </div>
        </div>
      </div>

      <div class="info-line">
        <div class="basic-item">
          <span class="label">证件类型</span>
          <div class="value is-form">
            <Select clearable v-model="basiInfo.cardType">
              <Option 
                :value="item.value" 
                v-for="(item, index) in cardTypeList" 
                :key="index"
              >
                {{ item.txt }}
              </Option>
            </Select>            
          </div>
        </div>

        <div class="basic-item">
          <span class="label">证件号</span>
          <div class="value is-form">
            <Input v-model="basiInfo.cardNo" placeholder="请输入" :maxlength="18" clearable />            
          </div>
        </div>

        <div class="basic-item">
          <span class="label">证件有效期</span>
          <div class="value is-form">
            <DatePicker
              v-if="basiInfo.isLong!='1'"
              type="daterange"
              format="yyyy-MM-dd"
              split-panels
              v-model="certificateValidity"
              placeholder="请选择"
              style="width:100%;"
            ></DatePicker>

            <DatePicker
              v-else
              type="date"
              format="yyyy-MM-dd"
              split-panels
              v-model="basiInfo.cardStartDate"
              placeholder="请选择"
              style="width:100%;"
            ></DatePicker>
          </div>
          <i-switch v-model="basiInfo.isLong" size="large" true-value="1" false-value="0" style="margin-left:5px;min-width:55px;" @on-change="isLongEffectiveChange">
            <span slot="open">长期</span>
            <span slot="close">短期</span>
          </i-switch>
        </div>

        <div class="basic-item">
            <span class="label">年龄</span>
            <span class="value">{{ basiInfo.age }}</span>
          </div>
        </div>

        <div class="info-line">
        <div class="basic-item">
          <span class="label">所在地区</span>
          <div class="value is-form">
            <Select v-model="basiInfo.province" placeholder="省" @on-change="provinceChange($event)" filterable style="width: calc(50% - 5px);">
              <Option v-for="(item,i) in regionsArr" :value="item.name" :key="i">{{ item.name }}</Option>
            </Select>

            <Select v-model="basiInfo.city" placeholder="市" @on-change="cityChange($event)" filterable style="width: calc(50% - 5px);">
              <Option v-for="(item,i) in cityList2" :value="item.name" :key="i">{{ item.name }}</Option>
            </Select>

            <Select v-model="basiInfo.area" placeholder="区" filterable style="width: calc(50% - 5px);">
              <Option v-for="(item,i) in cityList3" :value="item.name" :key="i">{{ item.name }}</Option>
            </Select>
          </div>
        </div>

        <div class="basic-item" style="width:50%;">
          <span class="label">详细地址</span>
          <div class="value is-form" style="width:calc(50% + 240px);">
            <Input v-model="basiInfo.address" placeholder="请输入" :maxlength="50" clearable />
          </div>
        </div>

        <div class="basic-item">
          <span class="label">职业</span>
          <div class="value is-form">
            <Input v-model="basiInfo.profession" placeholder="请输入" :maxlength="15" clearable />
          </div>
        </div>
      </div>

      <div class="info-line">
        <div class="basic-item">
          <span class="label">微信昵称</span>
          <span class="value">{{ basiInfo.nickname?basiInfo.nickname:'-' }}</span>
          <a class="action-icon" v-if="basiInfo.nickname" @click="copyWechat(basiInfo.nickname)">
            <img src="@/assets/images/icon/org/copy.png"/>
          </a>
        </div>

        <div class="basic-item">
          <span class="label">民族</span>
          <div class="value is-form">
            <Input v-model="basiInfo.nation" placeholder="请输入" clearable />
          </div>
        </div>

        <div class="basic-item">
          <span class="label">邮箱</span>
          <div class="value is-form">
            <FormItem prop="email" :rules="$units.formRule.email(false)">
              <Input v-model="basiInfo.email" placeholder="请输入" clearable />
            </FormItem>
          </div>
        </div>

        <div class="basic-item">
          <span class="label">身高(cm)</span>
          <div class="value is-form">
            <FormItem prop="height" :rules="$units.formRule.height(false, '请输入正整数')">
              <Input v-model="basiInfo.height" :maxlength="3" placeholder="请输入" clearable />
            </FormItem>
          </div>
        </div>
      </div>

      <div class="info-line">
        <div class="basic-item">
          <span class="label">体重（kg）</span>
          <div class="value is-form">
            <FormItem prop="weight" :rules="$units.formRule.weight(false, '请按格式要求输入')">
              <Input v-model="basiInfo.weight" placeholder="支持3位正整数，保留两位点后小数" clearable />
            </FormItem>            
          </div>
        </div>

        <div class="basic-item">
          <span class="label">家庭关系</span>
          <div class="value is-form">
            <Select clearable v-model="basiInfo.familyRelationship">
              <Option
                :value="item.value"
                v-for="(item, index) in familyRelations" 
                :key="index"
              >
                {{ item.txt }}
              </Option>
            </Select>
          </div>
        </div>

        <div class="basic-item">
          <span class="label">身体情况</span>
          <div class="value is-form">
            <Select clearable v-model="basiInfo.health">
              <Option
                :value="item.value"
                v-for="(item, index) in healthList" 
                :key="index"
              >
                {{ item.txt }}
              </Option>
            </Select>
          </div>
        </div>

        <div class="basic-item">
          <span class="label">有无社保</span>
          <div class="value is-form">
            <Select clearable v-model="basiInfo.socialSecurity">
              <Option value="1">有</Option>
              <Option value="0">无</Option>
            </Select>
          </div>
        </div>
      </div>

      <div class="info-line">
        <div class="basic-item">
          <span class="label">年收入（万元）</span>
          <div class="value is-form">
            <FormItem prop="income" :rules="$units.formRule.money(false, '请按格式要求输入')">
              <Input type="number" v-model.trim="basiInfo.income" placeholder="支持9位正整数，保留两位点后小数" clearable />
            </FormItem>            
          </div>
        </div>

        <div class="basic-item">
          <span class="label">贷款（元）</span>
          <div class="value is-form">
            <FormItem prop="liabilities" :rules="$units.formRule.money(false, '请按格式要求输入')">
              <Input type="number" v-model="basiInfo.liabilities" placeholder="支持9位正整数，保留两位点后小数" clearable />
            </FormItem>            
          </div>
        </div>

        <div class="basic-item">
          <span class="label">月支出（元）</span>
          <div class="value is-form">
            <FormItem prop="spend" :rules="$units.formRule.money(false, '请按格式要求输入')">
              <Input v-model="basiInfo.spend" placeholder="支持9位正整数，保留两位点后小数" clearable />
            </FormItem>            
          </div>
        </div>

        <div class="basic-item">
          <span class="label">保险预算（元）</span>
          <div class="value is-form">
            <FormItem prop="budget" :rules="$units.formRule.money(false, '请按格式要求输入')">
              <Input v-model="basiInfo.budget" placeholder="支持9位正整数，保留两位点后小数" clearable />
            </FormItem>            
          </div>
        </div>
      </div>

      <div class="info-line">
        <div class="basic-item">
          <span class="label">客户来源</span>
          <div class="value is-form">
            <Select clearable v-model="basiInfo.source">
              <Option 
                :value="item.code" 
                v-for="(item, index) in sourceList" 
                :key="index"
              >
                {{ item.name }}
              </Option>
            </Select>
          </div>
        </div>

        <div class="basic-item">
          <span class="label">为谁配置保险</span>
          <div class="value is-form">
            <Select clearable :multiple="true" v-model="basiInfo.forWhoInsured" :max-tag-count="1">
              <Option 
                :value="item.value" 
                v-for="(item, index) in insuranceConfigList" 
                :key="index"
              >
                {{ item.txt }}
              </Option>
            </Select>
          </div>
        </div>

        <div class="basic-item">
          <span class="label">是否购买商业险</span>
          <div class="value is-form">
            <RadioGroup v-model="basiInfo.businessRisk">
                <Radio label="1">是</Radio>
                <Radio label="0">否</Radio>
            </RadioGroup>
          </div>
        </div>

        <div class="basic-item">
          <span class="label">关注的产品</span>
          <div class="value is-form">
            <Input v-model="basiInfo.focusProducts" placeholder="请输入" :title="basiInfo.focusProducts" :maxlength="50" clearable />
          </div>
        </div>
      </div>

      <div class="info-line">
        <div class="basic-item">
          <span class="label">客户需求</span>
          <div class="value is-form">
            <Select :multiple="true" clearable v-model="basiInfo.demand" :max-tag-count="1">
              <Option
                :value="item.value" 
                v-for="(item, index) in customerDemandList" 
                :key="index"
              >
                {{ item.txt }}
              </Option>
            </Select>
          </div>
        </div>

        <div class="basic-item">
          <span class="label">客户类型</span>
          <span class="value">{{ basiInfo.type=='1'?'预约客户':'自有客户' }}</span>
        </div>

        <div class="basic-item">
          <span class="label">创建时间</span>
          <span class="value">{{ filter.filterTime(basiInfo.createTime, 'YYYY-MM-DD HH:mm') }}</span>
        </div>

        <div class="basic-item">
          <span class="label">归属机构</span>
          <span class="value">{{ basiInfo.orgName }}</span>
        </div>
      </div>

      <div class="info-line">
        <div class="basic-item">
          <span class="label">归属团队</span>
          <span class="value">{{ basiInfo.groupName }}</span>
        </div>

        <div class="basic-item">
          <span class="label">归属业务员</span>
          <span class="value">{{ basiInfo.agentName }}</span>
        </div>

        <div class="basic-item">
          <span class="label">最新预约时间</span>
          <span class="value">{{ filter.filterTime(basiInfo.lastSubscribeDate, 'YYYY-MM-DD HH:mm') }}</span>
        </div>

        <div class="basic-item">
          <span class="label">咨询次数</span>
          <span class="value">{{ basiInfo.consultNum }}</span>
        </div>      
      </div>

      <div class="info-line">
        <div class="basic-item" style="width:50%;">
          <span class="label">备注</span>
          <div class="value is-form" style="width:calc(50% + 240px);">
            <Input v-model="basiInfo.remark" placeholder="请输入" :title="basiInfo.remark" :maxlength="150" clearable />
          </div>
        </div>
      </div>

      <div class="info-other">
        <div class="info-other-item" v-for="(item, index) in extraFileds" :key="index">
          <span class="label">{{ item.name }}</span>
          <span class="value">{{ item.value }}</span>
        </div>
      </div>
    </Form>
  </div>
</template>
<script>
import { getCustomerDemand, getConfigInsurance, getCardType, getFamilyRelations, getHealth } from "../../form/api";
import filter from "@/api/filter";
import {common} from "@/api/mixins";

export default {
  name: "detailBasicInfo",
  props:['id'],
  mixins:[common],
  data() {
    return {
      customerDemandList:[],
      insuranceConfigList:[],
      regionsArr:[],//省
      cityList2:[],//市
      cityList3:[],//区
      sourceList: [],//客户来源
      cardTypeList:[],//证件类型
      familyRelations:[],//家庭关系
      healthList:[],//健康状况
      certificateValidity:[],//证件有效期
      basiInfo:{},
      extraFileds:[],
      httpCode:null,
      filter,
      userId:JSON.parse(localStorage.getItem('userInfo')).userid,
      eyeShow:false,
      userSex:''
    };
  },
  activated() {
    this.getInsureList();
  },
  async created(){
    await this.getRegion();
    this.queryCustomerDemand();
    this.queryConfigInsurance();    
    this.queryCardType();
    this.queryFamilyRelations();
    this.queryHealth();
    this.getInsureList();
  },
  methods: {
    // 获取省市区域数据
    async getRegion() {
      this.regionsArr = await this.$store.dispatch("getRegion");
    },

    // 选择省
    provinceChange(name){
      const data = this.regionsArr.find(item=>item.name == name);
      this.cityList2 = data.children;
      this.basiInfo.area = '';
      this.basiInfo.city = '';
    },

    // 选择区
    cityChange(name){
      const data = this.cityList2.find(item=>item.name == name);
      this.cityList3 = data.children;
      this.basiInfo.area = '';
    },

    getInsureList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/customerBase/queryDetail",
        type: "GET",
        data: {
          id:this.id
        },
      }).then((res) => {
        this.getSourceList(res.data.type);
        this.basiInfo = res.data;
        this.userSex = res.data.sex;
        this.$root.$children[0].isShowLoading = false;

        if(res.data.province){
          const data1 = this.regionsArr.find(item=>item.name == res.data.province);
          this.cityList2 = data1.children;
          const data = this.cityList2.find(item=>item.name == res.data.city);
          this.cityList3 = data.children;
        }
        
        if(res.data.demand){
          this.basiInfo.demand = res.data.demand.split(',');
        }

        if(res.data.forWhoInsured){
          this.basiInfo.forWhoInsured = res.data.forWhoInsured.split(',');
        }

        if(res.data.cardStartDate&&res.data.cardEndDate){
          this.certificateValidity=[res.data.cardStartDate, res.data.cardEndDate];
        }

        if(res.data.extraFileds){
          this.extraFileds = JSON.parse(res.data.extraFileds);
        }

        if(!res.data.isLong){
          this.basiInfo.isLong = '0';
        }
      })     
    },

    // 客户需求
    async queryCustomerDemand() {
      const {data} = await getCustomerDemand();
      this.customerDemandList = data;
    },

    // 为谁配置保险
    async queryConfigInsurance() {
      const {data} = await getConfigInsurance();
      this.insuranceConfigList = data;
    },

    // 证件类型
    async queryCardType() {
      const {data} = await getCardType();
      this.cardTypeList = data;
    },

    // 客户需求
    filterCustomerDemand(value) {
      if(!value)return;
      let str = [];
      this.customerDemandList.filter(item=>{
        value.split(',').map(item2=>{
          if(item.value == item2){
            str.push(item.txt)
          }
        })
      })
      return str.join('、')
    },

    // 客户来源
    getSourceList(type){
      this.$http({
        url: "/buz/subscribe/querySourceList",
        type: "PUT",
        data:{type}
      }).then((res) => {
        this.sourceList = res.data;
      })
    },

    // 家庭关系
    async queryFamilyRelations() {
      const { data } = await getFamilyRelations();
      this.familyRelations = data;
    },

    // 健康状况
    async queryHealth() {
      const {data} = await getHealth();
      this.healthList = data;
    },

    // 取消
    closePage() {
      window.setTimeout(()=>{
        window.parent.postMessage({
          removePageTag: this.$route.fullPath,
          appMessage: true,
        }, "*");
      },100)
    },

    // 微信昵称复制
    copyWechat(value) {
      let oInput = document.createElement("input");
      oInput.value = value;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$Message.success("复制成功");
    },

    openEye() {
      if(!this.eyeShow){
        this.descrypt({
          query:this.basiInfo.id,
          operationFunction:6,
          operationType:2,
        },this.basiInfo, 'mobile1').then(()=>{
          this.eyeShow=true
        })
      }else{
        this.eyeShow = false;
      }
    },

    // 访问时间处理
    handleAccessTime(time) {
      if(!time)return;
      const toDay = this.toTimeStamp(filter.filterTime(Date.parse(new Date()), 'YYYY-MM-DD'));
      const targetTime = this.toTimeStamp(filter.filterTime(time, 'YYYY-MM-DD'));
      let max = '', min = '';
      if(toDay>targetTime){
        max = toDay
        min = targetTime
      }else{
        max = targetTime
        min = toDay
      }

      if((max-min)/(24*60*60*1000)==0){
        return '今天' + filter.filterTime(time, 'HH:mm');
      }else if((max-min)/(24*60*60*1000)==1) {
        return '明天' + filter.filterTime(time, 'HH:mm');
      }else{
        return filter.filterTime(time, 'YYYY-MM-DD HH:mm')
      }
    },

    // 时间戳转换
    toTimeStamp(dateString) {
      return new Date(dateString) - 0
    },

    // 身份证有效期类型切换
    isLongEffectiveChange() {
      if(this.basiInfo.isLong=='1'){
        this.certificateValidity = [];
      }
    },

    // 提交
    ok() {
      this.$refs.form.validate().then((isok) => {
        if (!isok) {
          return;
        }
        this.save();
      });
    },

    // 保存
    save() {
      const data = JSON.parse(JSON.stringify(this.basiInfo));
      if(data.birthDate){
        data.birthDate=filter.filterTime(data.birthDate, 'YYYY-MM-DD')
      }

      if(data.isLong=='0'){
        // 证件有限期始
        if(this.certificateValidity[0] && this.certificateValidity[0] !='-'){
          data.cardStartDate=filter.filterTime(this.certificateValidity[0], 'YYYY-MM-DD');
        }else{
          data.cardStartDate='';
        }

        // 证件有限期止
        if(this.certificateValidity[1] && this.certificateValidity[1] !='-'){
          data.cardEndDate=filter.filterTime(this.certificateValidity[1], 'YYYY-MM-DD');
        }else{
          data.cardEndDate='';
        }
      }else{
        if(data.cardStartDate && data.cardStartDate !='-'){
          data.cardStartDate=filter.filterTime(data.cardStartDate, 'YYYY-MM-DD');
        }else{
          data.cardStartDate='';
        }
      }

      if(data.cardNo1){
        data.cardNo = data.cardNo1;
      }

      if(data.demand){
        data.demand = data.demand.join(',');
      }

      if(data.forWhoInsured){
        data.forWhoInsured = data.forWhoInsured.join(',');
      }

      if(!data.sex){
        data.sex = '';
      }

      if(!data.cardType){
        data.cardType = '';
      }

      if(!data.familyRelationship){
        data.familyRelationship = '';
      }

      if(!data.health){
        data.health = '';
      }

      if(!data.socialSecurity){
        data.socialSecurity = '';
      }
      
      if(!data.source){
        data.source = '';
      }
      this.$http({
        url: "/buz/customerBase/update",
        type: "POST",
        data
      }).then((res) => {
        this.getInsureList();
        this.$Message.success("保存成功");
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.basic-info-box {
  position: relative;
  .action-box {
    position: absolute;
    display: flex;
    right: 0;
    top: -65px;
    .cancel {
      width: 80px;
      height: 30px;
      background-color: #F2F6FF;
      border-radius: 2px;
      color: #236DFF;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
    }
    .save {
      width: 80px;
      height: 30px;
      background-color: #236DFF;
      border-radius: 2px;
      color: #fff;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 30px;
    }
  }
  .user-info-box {
    display: flex;
    height: 68px;
    padding: 0 10px;
    margin:10px 0 30px 0;
    .img-type {
      position: relative;
      .head-portrait {
        width: 68px;
        height: 68px;
        border-radius: 50%;
      }
      .tag {
        position: absolute;
        bottom: -8px;
        left: 50%;
        margin-left: -18px;
        width: 36px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #F5F7F9;
        font-size: 10px;
        color: #727C8E;
      }
    }
    
    .birthday-box {
      display: flex;
      justify-content: space-between;
      margin-left: 14px;
      flex-direction: column;
      .appointment-birthday {
        margin-top: 6px;
        display: flex;
        border-radius: 2px;
        .appointment {
          background: #FFFAF2;
          margin-right: 20px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 10px;
          img {
            margin-right: 10px;
            width: 12px;
            height:12px;
          }
          .text {
            font-size:12px;
            color:#F59045;
          }
        }
      }
      a {
        color: #236DFF;
      }
    }
  }
  .info-line {
    width: 100%;
    margin-bottom: 20px;
    display: flex;

    .basic-item {
      width: 25%;
      display: flex;
      align-items: center;
      .label {
        width: 90px;
        text-align: right;
        font-size: 12px;
        color: #727c8e;
        white-space: nowrap;
      }
      .value {
        padding: 0 10px;
        border-radius: 2px;
        display: flex;
        align-items: center;
        margin-left: 10px;
        width: 240px;
        height: 30px;
        color: #515c6f;
        background-color: #f5f7f9;
        font-size: 12px;
      }
      & .is-form {
        padding: 0 0px;
        background: none;
        display: flex;        
        align-items: center;
        .ivu-form-item {
          width: 100%;
          padding-right: 0px;
          padding-bottom: 0;
          margin-top: 22px;
        }
      }
      .value::-webkit-scrollbar{
        display:none;
      }
      .value:hover {
        cursor: not-allowed;
      }
      .action-icon {
        color: none;
        margin-left: 8px;
        img {
          width: 16px;
          height: 16px;
        }
        .eye {
          color: #A8ADB7;
        }
      }
    }
  }
  .info-other {
    display: flex;
    flex-wrap: wrap;
    .info-other-item {
      display: flex;
      align-items: center;
      width: 25%;
      margin-bottom: 20px;
      .label {
        width: 90px;
        text-align: right;
        font-size: 12px;
        color: #727c8e;
        white-space: nowrap;
      }
      .value {
        padding: 0 10px;
        border-radius: 2px;
        display: flex;
        align-items: center;
        margin-left: 10px;
        width: 240px;
        height: 30px;
        color: #515c6f;
        background-color: #f5f7f9;
        white-space: nowrap;
        overflow: hidden;
        overflow-x: auto;
        -ms-overflow-style: none;
        overflow: -moz-scrollbars-none;
      }
      .value:hover {
        cursor: not-allowed;
      }
    }
  }
}
</style>